import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
 selector: '[appAfterViewFocus]',
})
export class AfterViewFocusDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    //https://stackoverflow.com/questions/25241544/angular-bootstrap-modal-popup-autofocus-not-working  - give settimeout for focus to work
    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    });
  }

}
